import { render, staticRenderFns } from "./PendingUser.vue?vue&type=template&id=2332fcf7&scoped=true&"
import script from "./PendingUser.vue?vue&type=script&lang=js&"
export * from "./PendingUser.vue?vue&type=script&lang=js&"
import style0 from "./PendingUser.vue?vue&type=style&index=0&id=2332fcf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2332fcf7",
  null
  
)

export default component.exports